const REPORT_FILTERS_ENDPOINT = `/reporting-discovery/v1/report-template/filters`;
const REPORT_TEMPLATES_BASE_URL = '/reporting-discovery/v1/report-template';
const LIBRARY_RECOMMENDATIONS_GATE = 'RH:ReportLibraryRecommendations';
const quickFetch = window.quickFetch;
(function () {
  quickFetch.makeEarlyRequest('reportFilters', {
    url: quickFetch.getApiUrl(REPORT_FILTERS_ENDPOINT),
    timeout: 15000,
    dataType: 'json',
    contentType: 'application/json',
    type: 'GET'
  });
})();
(function () {
  quickFetch.afterAuth(authData => {
    if (authData.portal.enabled_v3_gates.includes(LIBRARY_RECOMMENDATIONS_GATE)) {
      quickFetch.makeEarlyRequest('reportRecommendationCandidates', {
        url: quickFetch.getApiUrl(`${REPORT_TEMPLATES_BASE_URL}?hydrate=TOOL&statuses=ACTIVE&statuses=CHANGES_REQUESTED&hiddenFromLibrary=false`),
        timeout: 15000,
        dataType: 'json',
        contentType: 'application/json',
        type: 'GET'
      });
    }
  });
})();